import { OrderQuoteModel } from "contents/create-order/types";
import { createContext, ReactNode, useCallback, useContext, useState } from "react";

export const defaultQuote: OrderQuoteModel = {
  id: undefined,
  salesRep: '',
  salesRepLocation: 0,
  salesRepEmail: '',
  customerId: undefined,
  customerCompanyName: '',
  customerFirstName: '',
  customerLastName: '',
  customerEmail: '',
  customerPhone: '',
  customerPurchaseOrder: '',
  createContact: false,
  contactId: undefined,
  fax: '',
  orderType: 'Embroidery',
  requestedShippingDate: '',
  dropDeadDate: '',
  shippingMethod: 'Pick Up',
  quotedLogos: [],
  quotedProducts: [],
  notesToCSR: '',
  notesToProduction: '',
  notesToReceiving: '',
  notesToPurchasing: '',
  notesToShipping: '',
  notesToAccounting: '',
}

export const SelectedQuoteContext = createContext<OrderQuoteModel>(defaultQuote);
export const SelectedQuoteUpdateContext = createContext<(selectedQuote?: OrderQuoteModel) => void>((...args) => { });

export function useSelectedQuote() {
  return useContext(SelectedQuoteContext);
}

export function useSelectedQuoteUpdate() {
  return useContext(SelectedQuoteUpdateContext);
}

type Props = {
  children?: ReactNode;
};

export function SelectedQuoteProvider(props: Props) {
  const { children } = props;
  const [selectedQuote, setSelectedQuote] = useState<OrderQuoteModel>(defaultQuote);

  const changeSelectedQuote = useCallback((value?: OrderQuoteModel) => {
    setSelectedQuote(value ?? { ...defaultQuote, quotedLogos: [], quotedProducts: [] });
  }, []);

  return (
    <SelectedQuoteContext.Provider value={selectedQuote}>
      <SelectedQuoteUpdateContext.Provider value={changeSelectedQuote}>
        {children}
      </SelectedQuoteUpdateContext.Provider>
    </SelectedQuoteContext.Provider>
  );
}
